export const DemoSettings_TYPE_REQUEST = "DemoSettings_TYPE_REQUEST";
export const DemoSettings_TYPE_SUCCESS = "DemoSettings_TYPE_SUCCESS";
export const DemoSettings_TYPE_FAILURE = "DemoSettings_TYPE_FAILURE";

export const DemoSettings_UPDATE_REQUEST = "DemoSettings_UPDATE_REQUEST";
export const DemoSettings_UPDATE_SUCCESS = "DemoSettings_UPDATE_SUCCESS";
export const DemoSettings_UPDATE_FAILURE = "DemoSettings_UPDATE_FAILURE";
export const DemoSettings_UPDATE_RESET = "DemoSettings_UPDATE_RESET";